"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labelClass = exports.dropDownClass = exports.containerClass = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var containerClass = function containerClass(props, state) {
  return (0, _classnames["default"])({
    'ui-date-field': true,
    'ui-form-field': true,
    'ui-form-field--inline': props.inline,
    'ui-form-field--has-error': props.hasError,
    'ui-form-field--disabled': props.disabled,
    'ui-date-field--has-error': props.hasError,
    'ui-date-field--droptdown-open': state.isOpen
  }, props.className);
};

exports.containerClass = containerClass;

var labelClass = function labelClass(props) {
  var _classNames;

  return (0, _classnames["default"])((_classNames = {
    'ui-form-field__label': true,
    'ui-form-field__label--required': props.required
  }, _defineProperty(_classNames, props.labelClassName, !_lodash["default"].isEmpty(props.labelClassName)), _defineProperty(_classNames, 'sr-only', props.hideLabel), _classNames));
};

exports.labelClass = labelClass;

var dropDownClass = function dropDownClass(state) {
  return (0, _classnames["default"])({
    'ui-date-field__dropdown': true,
    'ui-date-field__dropdown--open': state.isOpen
  });
};

exports.dropDownClass = dropDownClass;